import React from "react";
import {registerPassages, jumpTo} from "../../Utils";
import variables from "../variables";
import people from "../people/people";
import {changeTimeTo, setBackGroundColor, notify} from "../features/functions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import Input from "../../features/Input";
import images from "../images";
import {store} from "../../app/store";
import {setDialogContent} from "../../app/projectSlice";
import {Col, Container, Row} from "react-bootstrap";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

const checkPlayerName = name => {
    if (name === "") name = variables.player.name;
    people.player.setName(name);
    notify(<span><Trans i18nKey="start.checkPlayerName">1<span style={{color: people.player.color}}>{{name}}</span></Trans></span>);
    jumpTo("start.wifeNameInput");
};

const checkWifeName = name => {
    if (name === "") name = variables.wife.name;
    people.wife.setName(name);
    notify(<span><Trans i18nKey="start.checkWifeName">1<span style={{color: people.wife.color}}>{{name}}</span></Trans></span>);
    jumpTo("start.wifeNicknameInput");
};

const checkWifeNickName = nickname => {
    if (nickname === "") nickname = variables.wife.nickname;
    people.wife.setNickname(nickname);
    notify(<span><Trans i18nKey="start.checkWifeNickName">1<span style={{color: people.wife.color}}>{{nickname}}</span></Trans></span>);
    jumpTo("start.story");
};

const startPassage = <Passage>
    <V callback={()=>{setBackGroundColor("white")}}/>
    <Container>
        <Row className="game-badges" style={{marginLeft: "-200px", marginTop: "100px"}}>
            <Col xl={12}>
                <a href="https://www.patreon.com/le_creatore" target="_blank">
                    <img style={{width: "70px"}} src={images.game.patreon} alt=""/>
                </a>
            </Col>
            <Col xl={12}>
                <a href="https://www.buymeacoffee.com/lecreatore" target="_blank">
                    <img style={{width: "70px"}} src={images.game.buyMeACoffee} alt=""/>
                </a>
            </Col>
            <Col xl={12}>
                <a href="https://giphy.com/search/adult" target="_blank">
                    <img style={{width: "70px"}} src={images.game.adult} alt=""/>
                </a>
            </Col>
        </Row>
    </Container>
    <Container>
        <Row><Col sm={8} xl={6} className="game-name"><img src={images.game.name} alt=""/></Col></Row>
    </Container>
    <div className="start-image"><img src={images.game.mainImage} alt=""/></div>
    <br/>
    <Trans i18nKey="start.startPassage">
        1<span style={{color: "red", fontSize: "150%"}}/><b/><b/>
        <Link to="start.playerNameInput" div style={{fontSize: "200%"}}/><br/>
        <Link to="" style={{fontSize: "200%"}} div callback={()=>{
            store.dispatch(setDialogContent("loadMenu"));
        }}/>
    </Trans>
</Passage>

const playerNameInput = <Passage>
    <Trans i18nKey="start.playerNameInput">
        1<h1/><Image src={images.player.name}/><b/>{{name: variables.player.name}}
    </Trans> <Input callback={checkPlayerName}/>
</Passage>

const wifeNameInput = <Passage>
    <Trans i18nKey="start.wifeNameInput">
        1<h1/><Image src={images.wife.name}/><b/>{{name: variables.wife.name}}
    </Trans> <Input callback={checkWifeName}/>
</Passage>

const wifeNicknameInput = <Passage>
    <Trans i18nKey="start.wifeNicknameInput">
        1<h1/><Image src={images.wife.name}/><Name who={people.wife}/><b/>{{nickname: variables.wife.nickname}}
    </Trans> <Input callback={checkWifeNickName}/>
</Passage>

const story = <Passage>
    <Trans i18nKey="start.story">
        1<h1/><Image src={images.places.town}/><Name who={people.player}/><Name who={people.father}/>
        <Name who={people.mother}/><Name who={people.sister}/><Image src={images.places.familyMansion}/><Link to="start.wife"/>
        {{surname: people.player.surname, age: people.player.age, town: variables.town.name, city: variables.city.name}}
    </Trans>
</Passage>

const wife = <Passage>
    <Trans i18nKey="start.wife">
        1<h1/><Image src={images.story.couple}/><Name who={people.wife}/><Image src={images.places.homes.initHome.homeMain}/>
        <Name who={people.wife} nickname/>
        <Link to="start.author" callback={() => {
            variables.game.wasStarted = true;
            people.wife.occupations.set("appearance", "appearance01");
        }}/>
    </Trans>
</Passage>

const author = <Passage>
    <Trans i18nKey="start.author">
        1<h1/><Image src={images.story.couple2}/><Name who={people.player}/><Name who={people.wife}/>
        <Name who={people.wife} nickname/><i style={{color: "red"}}/><br/>
        <Link to="game.changeDay" callback={() => {
            changeTimeTo(0, 0, 1);
            variables.game.nextDayLink = "day01.wakeup";
            people.wife.occupations.set("sleep");
        }}/>
        {{game: "Lermose: McNiel Story!"}}
    </Trans>
</Passage>


registerPassages({
    startPassage,
    playerNameInput,
    wifeNameInput,
    wifeNicknameInput,
    story,
    wife,
    author
}, "start");